import { FilterRoute } from '@zonofi/zono-money-store';

const ROUTES_WITH_DATE_FILTER: FilterRoute[] = [
  FilterRoute.Order,
  FilterRoute.Payment,
  FilterRoute.Invoice,
  FilterRoute.Conversation,
  FilterRoute.Ledger,
  FilterRoute.Dispatch,
  FilterRoute.Turnover,
  FilterRoute.CustomerOrder,
  FilterRoute.CustomerPayment,
  FilterRoute.CustomerInvoice,
  FilterRoute.CustomerDispatch,
  FilterRoute.SemanticQuery,
];

export function showDateFilter(route: FilterRoute): boolean {
  return ROUTES_WITH_DATE_FILTER.includes(route);
}
